import { useState } from 'react';
import { createPortal } from 'react-dom';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import Icon from '../common/Icon';
import BottomSheet from '../common/BottomSheet';
import { useAppBar } from '../../context/AppBarContext';
import { ReactComponent as PlusIcon } from '../../icons/plus.svg';
import { ReactComponent as AddIcon } from '../../icons/plus-circle.svg';
import { ReactComponent as PlayListPlusIcon } from '../../icons/playlist-plus.svg';
import { ReactComponent as XmarkIcon } from '../../icons/xmark.svg';

import './SongsMenu.scss';

function SongsMenu({
  pickedCount,
  serviceTitle,
  onNewSong,
  onCreateService,
  suggestedCount,
  onSuggestSongs,
  showSuggestButton,
  hasSuggestedSongs,
  hideNewSong,
  onDiscard,
}) {
  const { t } = useTranslation();
  const { actionsSlot, traySlot } = useAppBar();
  const [sheetOpen, setSheetOpen] = useState(false);

  const count = showSuggestButton ? suggestedCount : pickedCount;

  const choose = (action) => {
    setSheetOpen(false);
    action();
  };

  const create = !showSuggestButton && (
    <>
      <button
        type="button"
        className="SongsMenu create"
        aria-label={t('songsMenu.createAria')}
        aria-haspopup="dialog"
        aria-expanded={sheetOpen}
        onClick={() => setSheetOpen(true)}
      >
        <Icon icon={<PlusIcon />} />
      </button>

      <BottomSheet
        isOpen={sheetOpen}
        onClose={() => setSheetOpen(false)}
        title={t('songsMenu.create')}
        className="SongsMenu sheet"
      >
        {!hideNewSong && (
          <button type="button" className="option" onClick={() => choose(onNewSong)}>
            <Icon icon={<AddIcon />} />
            <span className="option-text">{t('songsMenu.newSong')}</span>
          </button>
        )}
        <button type="button" className="option" disabled={!pickedCount} onClick={() => choose(onCreateService)}>
          <Icon icon={<PlayListPlusIcon />} />
          <span className="option-text">
            {serviceTitle || t('songsMenu.newService')}
            <small>{pickedCount ? t('songsMenu.withPicked', { count: pickedCount }) : t('songsMenu.pickFirst')}</small>
          </span>
        </button>
      </BottomSheet>
    </>
  );

  const pill = count > 0 && (
    <div className={cx('SongsMenu picked', { suggested: hasSuggestedSongs })}>
      <span className="picked-label">
        {serviceTitle && !showSuggestButton ? (
          <>
            <span className="picked-title">{serviceTitle}</span> · {t('songs.count', { count })}
          </>
        ) : (
          t('songsMenu.picked', { count })
        )}
      </span>
      <button type="button" className="picked-discard" aria-label={t('songsMenu.discard')} onClick={onDiscard}>
        <Icon icon={<XmarkIcon />} />
      </button>
      <button type="button" className="picked-go" onClick={showSuggestButton ? onSuggestSongs : onCreateService}>
        {showSuggestButton
          ? t('songsMenu.suggest')
          : serviceTitle
            ? t('songsMenu.continue')
            : t('songsMenu.createService')}
      </button>
    </div>
  );

  return (
    <>
      {actionsSlot && create && createPortal(create, actionsSlot)}
      {traySlot && pill && createPortal(pill, traySlot)}
    </>
  );
}

export default SongsMenu;
